<template>
  <main class="flex-1 relative overflow-y-auto focus:outline-none" tabindex="0">
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8">
      <div class="md:flex md:items-center md:justify-between">
        <div class="flex min-w-0">
          <svg-vue class="content-title-icon" icon="font-awesome.edit-regular"></svg-vue>
          <h1 class="content-title">
            {{ $t('Terms and conditions') }}
          </h1>
        </div>
        <div class="mt-4 flex md:mt-0 md:ml-4">
          <router-link class="btn btn-app" to="/admin/settings">
            {{ $t('Back') }}
          </router-link>
        </div>
      </div>
    </div>
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8">
      <div class="content-card-body">
        <loading :status="loading"></loading>
        <form @submit.prevent="save">
          <div class="px-4 py-5 sm:p-6">
            <div class="grid grid-cols-3 gap-6">
              <div class="col-span-3">
                <label class="form-label" for="repair_invoice_terms">
                  {{ $t('Repair invoice terms') }}
                </label>
                <div class="pt-1">
                  <input-wysiwyg :plugins="{ images: false, quickReply: false, shortCode: true }" id="repair_invoice_terms" v-model="terms.repair_invoice_terms" />
                </div>
              </div>
              <div class="col-span-3">
                <label class="form-label" for="bill_invoice_terms">
                  {{ $t('Bill invoice terms') }}
                </label>
                <div class="pt-1">
                  <input-wysiwyg :plugins="{ images: false, quickReply: false, shortCode: true }" id="bill_invoice_terms" v-model="terms.bill_invoice_terms" />
                </div>
              </div>
              <div class="col-span-3">
                <label class="form-label" for="sale_invoice_terms">
                  {{ $t('Sale invoice terms') }}
                </label>
                <div class="pt-1">
                  <input-wysiwyg :plugins="{ images: false, quickReply: false, shortCode: true }" id="sale_invoice_terms" v-model="terms.sale_invoice_terms" />
                </div>
              </div>
              <div class="col-span-3">
                <label class="form-label" for="custom_buy_invoice_terms">
                  {{ $t('buy from customer invoice terms') }}
                </label>
                <div class="pt-1">
                  <input-wysiwyg
                    :plugins="{ images: false, quickReply: false, shortCode: true }"
                    id="custom_buy_invoice_terms"
                    v-model="terms.custom_buy_invoice_terms"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="inline-flex">
              <button class="btn btn-green" type="submit">
                {{ $t('Save') }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  name: 'terms',
  metaInfo() {
    return {
      title: this.$i18n.t('Terms'),
    };
  },
  data() {
    return {
      loading: true,
      terms: {
        repair_invoice_terms: null,
        bill_invoice_terms: null,
        sale_invoice_terms: null,
        custom_buy_invoice_terms: null,
      },
    };
  },
  mounted() {
    this.get();
  },
  methods: {
    get() {
      axios
        .get(route('settings.get.terms'))
        .then((response) => {
          this.terms = response.data;
          this.loading = false;
        })
        .catch(() => {
          this.$router.push('/admin/settings');
        });
    },
    save() {
      this.loading = true;
      axios
        .post(route('settings.set.terms'), this.terms)
        .then((response) => {
          this.loading = false;
          this.$notify({
            title: this.$i18n.t('Success').toString(),
            text: response.data.message.toString(),
            type: 'success',
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
